/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotDeliveryTarget {
    PROJECT_PARTICIPATION = "PROJECT_PARTICIPATION",
    REVIEW_CYCLE_NODE = "REVIEW_CYCLE_NODE"
}
